<template>

    <FloatingPanel
        :title="title"
        :saveable="false">

        <div class="canvas::editor-website-editors-loop-LoopPanel">

            <SwitchInput
                label="Aantal kolommen"
                instruction="Kies hier het aantal kolommen per rij."
                :items="[
                    { value: 2 },
                    { value: 3 },
                    { value: 4 },
                ]"
                :options="options"
                :defaultValue="3"
                options-property="columnsCount"
                @valueChange="save"
                :open="true"
            />

            <div class="m-5">

                <button
                    class="btn btn-blue"
                    @click="addItem">
                    <i class="fa fa-plus mr-1"></i> Item toevoegen
                </button>

            </div>

        </div>

    </FloatingPanel>

</template>

<script>

import LoopPanel from "galaxy/modules/Canvas/resources/js/editor/website/editors/loop/LoopPanel";
import FloatingPanel from "galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import SwitchInput from "galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: LoopPanel,

    components: {
        FloatingPanel,
        SwitchInput,
    }

}

</script>

<style lang="scss" scoped>


</style>
